
import * as React from "react"
import * as pluralize from "pluralize";
import { RentalAdvert, SaleAdvert, RentalAdvertObjectType } from "../../../types/types";


type Props = {
  advert: RentalAdvert | SaleAdvert
  objectName: string
}
export default (props: Props) : JSX.Element => (
  <ul className="crumbtrail">
    <li className="crumbtrail__crumb" itemScope={true} itemType="http://data-vocabulary.org/Breadcrumb">
      <a href="/" itemProp="url" className="crumbtrail__link">
        <span itemProp="title">{I18n.t('home_title')}</span>
      </a>
    </li>
    <li className="crumbtrail__crumb" itemScope={true} itemType="http://data-vocabulary.org/Breadcrumb">
      <a href={props.advert.overviewPath} itemProp="url" className="crumbtrail__link">
        <span itemProp="title">{I18n.t(pluralize(props.advert.type != 'sale' ? props.advert.objectType : 'sale'))}</span>
      </a>
    </li>
    {
      props.advert.region ?
        <li className="crumbtrail__crumb" itemScope={true} itemType="http://data-vocabulary.org/Breadcrumb">
          <a href={props.advert.regionOverviewPath} itemProp="url" className="crumbtrail__link">
            <span itemProp="title">{props.advert.region.name}</span>
          </a>
        </li>
      : ''
    }

    {
      props.advert.department ?
        <li className="crumbtrail__crumb" itemScope={true} itemType="http://data-vocabulary.org/Breadcrumb">
          <a href={props.advert.departmentOverviewPath} itemProp="url" className="crumbtrail__link">
            <span itemProp="title">{props.advert.department.name}</span>
          </a>
        </li>
      : ''
    }

    {
      props.advert.city ?
        <li className="crumbtrail__crumb" itemScope={true} itemType="http://data-vocabulary.org/Breadcrumb">
          <a href={props.advert.cityOverviewPath} itemProp="url" className="crumbtrail__link">
            <span itemProp="title">{props.advert.city.name}</span>
          </a>
        </li>
      : ''
    }

    <li className="crumbtrail__crumb">

      <div className="crumbtrail__link">
        {
          props.objectName ?
            props.objectName
          : I18n.t(`adverts.this_house.${props.advert.type != 'sale' ?  props.advert.objectType : 'sale_advert'}`)
        }
      </div>

    </li>
  </ul>
)
